import React from 'react';
import { Clip } from '@ff-os/rendering-shared/Clip';
import { Size } from '@ff-os/shared-utils/types/Size';
import { Crop } from 'react-image-crop/src/index';
import styles from './CropOverlay.module.scss';

export const CropOverlay = ({
    crop, clip, containerSize,
    url, filter
}: Props) => {

    if (!clip || clip.paths.length === 0 || !containerSize) {
        return null;
    }

    const dimensions = determineOverlaySize(crop, containerSize);
    const strokeSize = 2;

    const style = {
        width: dimensions.width - strokeSize,
        height: dimensions.height - strokeSize,
        backgroundImage: `url(${url})`,
        backgroundPosition: `${-dimensions.x}px ${-dimensions.y}px`,
        backgroundSize: `${containerSize?.width - strokeSize ?? 0}px ${containerSize?.height - strokeSize ?? 0}px`,
        filter: filter === 'grayscale' ? 'grayscale(1)' : 'none'
    };

    return (
        <div className={styles.container} style={style}>
            <div className={styles.overlay}>
                <svg className={styles.svg}
                    fill='white'
                    viewBox={`0 0 ${clip.width} ${clip.height}`}
                    clipPathUnits='objectBoundingBox'>
                    <path
                        width={dimensions.width}
                        height={dimensions.height}
                        d={clip.paths[0]}>
                    </path>
                </svg>
            </div>
        </div>
    );
};

type Props = {
    crop: Crop;
    url: string;
    clip: Clip | undefined;
    containerSize: Size | undefined;
    filter: string | null;
};

const determineOverlaySize = (crop: Crop, containerSize: Size) => {

    if (crop.unit === 'px') {
        return crop;
    }

    return {
        x: crop.x * containerSize.width / 100,
        y: crop.y * containerSize.height / 100,
        width: crop.width * containerSize.width / 100,
        height: crop.height * containerSize.height / 100
    };
};